import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchAll, create } from '../store/foodPackagesSlice';
import { useState } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { useModals } from '@mattjennings/react-modal-stack';
import ImagePickerModal from '../components/ImagePickerModal';
import { toast } from 'react-toastify';



function AddFoodPackage(props) {
    const { openModal } = useModals();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [ name, setName ] = useState('');
    const [ description, setDescription ] = useState('');
    const [ price, setPrice ] = useState('');

    async function onSubmit() {
        const res = await unwrapResult(await dispatch(create({
            name,
            description,
            price: price.replace(',', '.').replace(' ', '')
        })));
        if(!res) return;

        const { id } = res;

        toast.success('Uus toidupakk lisatud!');

        function callback() {
            dispatch(fetchAll());
            navigate('/platform/resources');
        }

        openModal(ImagePickerModal, { title: name, url: `/foodPackage/${id}/photo`, callback });
    }




    return (
        <div className="row p32 center-main">
            <div className="column g32">
                <h1>Lisa toidupakk</h1>

                <div className="line center-cross g32">

                    <div className="grow column g16">
                        <div className="column g4">
                            <b>Nimi</b>
                            <input type="text" autocomplete="off" value={name} onChange={(e) => setName(e.target.value)} />
                        </div>

                        <div className="column g4">
                            <b>Kirjeldus</b>
                            <input type="text" autocomplete="off" value={description} onChange={(e) => setDescription(e.target.value)} />
                        </div>

                        <div className="column g4">
                            <b>Hind</b>
                            <input type="text" autocomplete="off" value={price} onChange={(e) => setPrice(e.target.value)} placeholder='0.00' />
                        </div>
                    </div>
                </div>

                <button onClick={onSubmit}>Lisa toidupakk</button>
            </div>
        </div>
    );
};

export default AddFoodPackage;